<template>
    <div class="mine">
        <!-- 头部信息 -->
        <div class="flex__center__between header">
            <img :src="infos.headimgurl" alt="">
            <span class="fs_36 c_ff lh_60">{{infos.nickname}}</span>
            <!-- <div class="flex align-center vip-box">
                <span class="jcicon jcicon-vip5 fs_38 c_tip"></span>
                <span class="fs_24 c_ff">黄金会员</span>
            </div> -->
        </div>
        <!-- 订单那块的 -->
        <div class="order-box">
            <div class="flex__between__center order-box__header" v-link="'/Mall/MyOrder?index=0'">
                <div class="flex align-center">
                    <span class="jcicon jcicon-tongchoudingdan fs_40 c_4d"></span>
                    <span class="fs_28 c_4d">&ensp;我的订单</span>
                </div>
                <span class="jcicon jcicon-jiantouarrow487 fs_26 c_4d"></span>
            </div>
            <div class="flex__around order-nav">
                <div class="flex__center__between order-nav__item" v-link="'/Mall/MyOrder?index=1'">
                    <span class="jcicon jcicon-daifukuan1 fs_50 c_main"></span>
                    <span class="fs_26 c_4d mt_20">待付款</span>
                    <div class="tips" v-if="infos.bepaid">
                        <span class="fs_20 c_ff">{{infos.bepaid}}</span>
                    </div>
                </div>
                <div class="flex__center__between order-nav__item" v-link="'/Mall/MyOrder?index=2'">
                    <span class="jcicon jcicon-fahuo fs_50 c_main"></span>
                    <span class="fs_26 c_4d mt_20">待发货</span>
                    <div class="tips" v-if="infos.shipped">
                        <span class="fs_20 c_ff">{{infos.shipped}}</span>
                    </div>
                </div>
                <div class="flex__center__between order-nav__item" v-link="'/Mall/MyOrder?index=3'">
                    <span class="jcicon jcicon-daishouhuo1 fs_50 c_main"></span>
                    <span class="fs_26 c_4d mt_20">待收货</span>
                    <div class="tips" v-if="infos.eceived">
                        <span class="fs_20 c_ff">{{infos.eceived}}</span>
                    </div>
                </div>
                <div class="flex__center__between order-nav__item" v-link="'/Mall/MyOrder?index=4'">
                    <span class="jcicon jcicon-wancheng fs_50 c_main"></span>
                    <span class="fs_26 c_4d mt_20">已完成</span>
                </div>
            </div>
        </div>
        <!-- 子项 -->
        <div class="modular" v-for="(item,index) in nav_list" :key="index">
            <div class="flex__between__center modular__item" v-link="item1.path" v-for="(item1,index1) in item" :key="index1">
                <div class="flex align-center">
                    <span class="jcicon fs_40 c_4d" :class="item1.icon"></span>
                    <span class="fs_28 c_4d">&ensp;{{item1.text}}</span>
                </div>
                <span class="jcicon jcicon-jiantouarrow487 fs_26 c_4d"></span>
            </div>
        </div>
        <tab-bar :current='3'></tab-bar>
    </div>
</template>
<script>
export default {
    name: "Mine",
    data(){
        return{
            infos: {},
            nav_list:[
                [
                    {
                        text:'我的积分',
                        icon:'jcicon-qian',
                        path:'/Integral/Index'
                    },
                    {
                        text:'我的信息',
                        icon:'jcicon-xinxi',
                        path:'/Mall/Index'
                    },
                    {
                        text:'我的地址',
                        icon:'jcicon-dingwei',
                        path:'/address/Index'
                    },
                    {
                        text:'日历签到',
                        icon:'jcicon-rili',
                        path:'/Mall/Index'
                    },
                    {
                        text:'签到排行',
                        icon:'jcicon-paihang',
                        path:'/Mall/Index'
                    },
                    {
                        text:'我的收藏',
                        icon:'jcicon-paihang',
                        path:'/Mall/Collect'
                    },
                    {
                        text:'我的评价',
                        icon:'jcicon-paihang',
                        path:'/Mall/MyEvaluate'
                    },
                    {
                        text:'我的优惠券',
                        icon:'jcicon-paihang',
                        path:'/Coupon/Index'
                    }
                ],
                [
                    {
                        text:'拼团-首页',
                        icon:'jcicon-paihang',
                        path:'/Assemble/Index'
                    },
                    {
                        text:'拼团-我的订单',
                        icon:'jcicon-paihang',
                        path:'/Assemble/MyOrder?index=0'
                    },
                    {
                        text:'拼团-我的评价',
                        icon:'jcicon-paihang',
                        path:'/Assemble/MyEvaluate'
                    }
                ],
                [
                    {
                        text:'关于我们',
                        icon:'jcicon-qian',
                        path:'/Mine/About'
                    },
                    {
                        text:'联系我们',
                        icon:'jcicon-qian',
                        path:'/Mine/Contact'
                    },
                    {
                        text:'常见问题',
                        icon:'jcicon-qian',
                        path:'/Mine/Problem'
                    },
                    {
                        text:'意见反馈',
                        icon:'jcicon-qian',
                        path:'/Feedback/Index'
                    }
                ],
                [
                    {
                        text:'大转盘',
                        icon:'jcicon-qian',
                        path:'/Turntable/Index'
                    },
                    {
                        text:'帮助',
                        icon:'jcicon-qian',
                        path:'/Mall/Index'
                    }
                ]
            ]
        }
    },
    mounted(){
        this.axios.post('/wechat.php/Vip/getUserInfo',{
            openid: localStorage.openid,
        }).then(
            res=>{
                if(res.data.code==1){
                    this.infos=res.data.data;
                }
            }
        )
    }
}
</script>
<style scoped>
.header{
    padding: 30px 0;
    background: #F93A42;
}
.header img{
    width: 120px;
    height: 120px;
    border-radius: 50%;
}
.vip-box{
    height: 40px;
    padding: 0 10px;
    margin-top: 20px;
    background: rgba(0,0,0,0.5);
}
/* 订单 */
.order-box{
    padding: 30px 30px 0;
    background: #fff;
}
.order-box__header{
    height: 70px;
}
.order-nav{
    padding: 20px 0;
}
.order-nav__item{
    position: relative;
}
.order-nav__item .tips{
    position: absolute;
    top: -20px;
    right: -20px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #F93A42;
    line-height: 30px;
    text-align: center;
}
/* 子项 */
.modular{
    margin-top: 15px;
    background: #fff;
    padding: 0 30px;
}
.modular__item{
    height: 100px;
}
</style>





// WEBPACK FOOTER //
// src/pages/mine/Index.vue